function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.023 1.296L9.519 0 7.015 1.296l-2.787.423-1.263 2.52L.96 6.219 1.419 9 .96 11.781l2.005 1.98 1.263 2.52 2.787.423L9.52 18l2.504-1.296 2.787-.423 1.263-2.52 2.005-1.98L17.619 9l.459-2.781-2.005-1.98-1.264-2.52-2.786-.423zm1.793 1.79l-2.264-.344-2.033-1.053-2.033 1.053-2.265.344-1.026 2.047-1.629 1.608L2.94 9l-.375 2.259 1.63 1.608 1.026 2.047 2.265.344 2.033 1.053 2.034-1.053 2.263-.343 1.026-2.048 1.63-1.608L16.098 9l.372-2.259-1.629-1.608-1.026-2.047z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.518 17.69V24l6-1.5 6 1.5v-6.31l-3.027.46-2.973 1.539-2.973-1.54-3.027-.458z",
  fill: "#fff"
});

function SvgCertified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCertified;